import { render, staticRenderFns } from "./workerCertificateDoctorQua.vue?vue&type=template&id=b5b0c3be&"
import script from "./workerCertificateDoctorQua.vue?vue&type=script&lang=js&"
export * from "./workerCertificateDoctorQua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports